import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import type { CapabilityKey } from "../../lib/types";

interface CapabilityGuardProps {
  children: ReactNode;
  /** Capacidade exigida pra ver a rota (tabela rota->capacidade do plano
   * 2026-09-23, secao 5). super_admin sempre passa (bypass em useAuth().can). */
  need: CapabilityKey;
}

/**
 * Bloqueia acesso a rotas /admin/* pra quem nao tem a capacidade exigida.
 * Espera ja estar dentro de ProtectedRoute (auth garantido). Substitui o
 * antigo AdminGuard (superOnly/isAdmin booleano) — RBAC configuravel: a
 * decisao e por CAPACIDADE, nao por um papel fixo hardcoded na rota.
 */
export function CapabilityGuard({ children, need }: CapabilityGuardProps): JSX.Element {
  const { can } = useAuth();
  if (!can(need)) return <Navigate to="/" replace />;
  return <>{children}</>;
}
